import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Box } from "@mui/material";
// import VendorProductsTable from "../../components/backend/vendorProducts/VendorProductsTable";
import VendorProductsService from "../../service/vendor/VendorProductsService";
import IndexTable from "../../components/common/IndexTable";

function VendorProducts({ loading, setLoading }) {
	const pageTitle = "Vendor Products | RTO Mobile";

	return (
		<>
			<Helmet>
				<title>{pageTitle}</title>
				<meta name="robots" content="noindex,nofollow"></meta>
				<meta property="og:title" content={pageTitle} />
				<meta name="twitter:title" content={pageTitle} />
			</Helmet>
			<div className="rto_form-sections">
				<div className="rto_content-div" style={{ maxWidth: "1600px" }}>
					<Box
						display="flex"
						justifyContent="flex-end"
						backgroundColor="#f5f5f5"
						p={(0.5, 1)}
						borderRadius={1}
					>
						<Breadcrumbs aria-label="breadcrumb">
							<Link to="/dashboard" className="rto_link-2">
								Dashboard
							</Link>
							<Link to="/admin" className="rto_link-2">
								Admin
							</Link>
							<Typography>Vendor Products</Typography>
						</Breadcrumbs>
					</Box>
					<div className="rto_title-div">
						<h1 className="rto_page-title">Vendor Products</h1>
					</div>
					<p className="text-center">
						<a
							href="/vendors-products/create"
							className="btn btn-primary"
						>
							Create
						</a>
					</p>
					<div
						className="card card-outline card-primary"
						style={{
							borderTop: "3px solid #00aaff",
							boxShadow:
								"0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
						}}
					>
						<div className="card-body">
							{/* <VendorProductsTable
								loading={loading}
								setLoading={setLoading}
							/> */}
							<IndexTable
								loading={loading}
								setLoading={setLoading}
								service={VendorProductsService}
								title="Vendor Products"
								actionButtons={{
									viewLink: {
										path: "/vendors-products",
									},
									updateLink: {
										path: "/vendors-products/update",
									},
									delete: true,
								}}
								labels={[
									{
										id: "id",
										label: "ID",
									},
									{
										id: "sku",
										label: "SKU",
									},
									{
										id: "upc",
										label: "UPC",
									},
									{
										id: "name",
										label: "Name",
									},
									{
										id: "msrp",
										label: "MSRP",
									},
									{
										id: "is_inventory_item_name",
										label: "Inv. Item",
									},
									{
										id: "is_taxable_name",
										label: "Taxable",
									},
									{
										id: "vendors_products_serialtypes_name",
										label: "Serial Type",
									},
									{
										id: "vendors_manufacturers_name",
										label: "Manufacturer",
									},
									{
										id: "vendors_models_name",
										label: "Model",
									},
									{
										id: "status_name",
										label: "Status",
									},
									{
										id: "created_at",
										label: "Created At",
									},
									{
										id: "user_name",
										label: "Created By",
									},
								]}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default VendorProducts;
